// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Flyttet ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Kommando',
  accControlKey: () => 'Luk',
  accPositionAfter: () => 'efter',
  accPositionBefore: () => 'før',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Hold ' + p['keyPressed'] + ' og Shift nede, og anvend derefter piletasterne til at omsortere.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Indtast en komplet dato som denne: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Indtast en måned og et år som dette: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Gruppe',
  chart_labelSeries: () => 'Serier',
  chart_labelValue: () => 'Værdi',
  checkboxSet_requiredMessageDetail: () => 'Påkrævet',
  checkbox_requiredMessageDetail: () => 'Påkrævet',
  close: () => 'Luk',
  collection_noData: () => 'Ingen data at vise.',
  collection_selectAllRows: () => 'Vælg alle rækker',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vælg rækken ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Kan ikke sorteres',
  collection_sortEnabled: () => 'Kan sorteres',
  confirmation: () => 'Bekræftelse',
  datePicker_currentDate: () => 'Aktuel dato',
  datePicker_goToToday: () => 'Gå til i dag',
  datePicker_label: () => 'Datovælger',
  datePicker_month: () => 'Måned',
  datePicker_months: () => 'Måneder',
  datePicker_next: () => 'Næste',
  datePicker_nextDecade: () => 'Næste årti',
  datePicker_nextMonth: () => 'Næste måned',
  datePicker_prev: () => 'Forrige',
  datePicker_prevDecade: () => 'Forrige årti',
  datePicker_prevMonth: () => 'Forrige måned',
  datePicker_restricted: () => 'Begrænset',
  datePicker_selected: () => 'Valgt',
  datePicker_today: () => 'I dag',
  datePicker_weekNum: (p: { NUM: string }) => 'Uge ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Ugenummer',
  datePicker_year: () => 'År',
  datePicker_years: () => 'År ',
  error: () => 'Fejl',
  expandableList_expandCollapseInstructionText: () => 'Brug piletaster til at udvide og skjule',
  expandableList_groupCollapse: () => 'Skjult',
  expandableList_groupExpand: () => 'Udvidet',
  filePicker_addFiles: () => 'Tilføj filer',
  filePicker_dropzonePrimaryText: () => 'Træk og slip',
  filePicker_dropzoneSecondaryText: () => 'Vælg en fil, eller slip en her',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vælg eller slip filer her',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Du kan ikke uploade filer af typen: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Upload en fil ad gangen',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Du kan ikke uploade filer af typen ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'ukendt',
  formControl_clear: () => 'Ryd',
  formControl_day: () => 'Dag',
  formControl_helpAvailable: () => 'Hjælp tilgængelig',
  formControl_hide: () => 'Skjul',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Du har nået grænsen på ' +
    ((
      { one: new Intl.NumberFormat('da').format(p['CHARACTER_LIMIT']) + ' tegn' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('da').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('da').format(p['CHARACTER_LIMIT']) + ' tegn') +
    '.',
  formControl_loading: () => 'Indlæser',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Du kan indtaste op til ' + p['MAX_LENGTH'] + ' tegn.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' tegn tilbage.',
  formControl_month: () => 'Måned',
  formControl_readOnly: () => 'Skrivebeskyttet',
  formControl_requiredMessageDetail: () => 'Indtast en værdi.',
  formControl_show: () => 'Vis',
  formControl_year: () => 'År',
  gantt_labelDate: () => 'Dato',
  gantt_labelEnd: () => 'Slut',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Række',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Intet matchende afsnit fundet.',
  indexer_keyboardInstructionText: () => 'Tryk på Enter for at vælge en værdi.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mellem ' + p['FROM_SECTION'] + ' og ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dobbelttryk og hold for at aktivere bevægelsestilstand. Træk derefter op eller ned for at justere værdien.',
  info: () => 'Oplysninger',
  inputDateMask_date_cleared: () => 'Dato ryddet',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tom',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'åååå',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Indtast en dato, der ligger samtidig med eller før ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Indtast en dato, der ligger samtidig med eller efter ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Indtast en tilgængelig dato.',
  inputDatePicker_instruction: () => 'Tryk på Tab for at åbne kalenderen.',
  inputDatePicker_selectDate: () => 'Vælg en dato',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Indtast en måned og et år på eller før ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Indtast en måned og et år på eller efter ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Indtast et tal.',
  inputNumber_decrease: () => 'Formindsk',
  inputNumber_increase: () => 'Forøg',
  inputPassword_hidden: () => 'Adgangskode skjult',
  inputPassword_hide: () => 'Skjul adgangskode',
  inputPassword_show: () => 'Vis adgangskode',
  inputSensitiveText_hidden: () => 'Følsom tekst skjult',
  list_msgFetchCompleted: () => 'Indlæst',
  list_msgFetchingData: () => 'Indlæser',
  list_suggestion: () => 'Forslag',
  messageToast_allMessagesClosed: () => 'Alle toast-meddelelser er lukket.',
  message_close: () => 'Luk',
  message_confirmation: () => 'Gennemført',
  message_error: () => 'Fejl',
  message_info: () => 'Oplysninger',
  message_navigationFromMessagesRegion: () =>
    'Åbner meddelelsesområde. Tryk på F6 for at navigere tilbage til tidligere fokuseret element.',
  message_navigationToMessagesRegion: () =>
    'Meddelelsesområde har nye meddelelser. Tryk på F6 for at navigere til det seneste meddelelsesområde.',
  message_warning: () => 'Advarsel',
  noData_message: () => 'Ingen elementer at vise',
  overflowItemLabel: () => 'Flere faner',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'I gang',
  radio_helpForRadio: () => 'Hjælp til alternativknap',
  radio_requiredMessageDetail: () => 'Vælg en værdi.',
  selectMultiple_apply: () => 'Anvend',
  selectMultiple_back: () => 'Tilbage',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Brug venstre og højre piletast til at fremhæve valgte værdier.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Tryk på Tilbage eller Slet for at fjerne den valgte værdi.',
  selectMultiple_selectedValues: () => 'Valgte værdier',
  selectMultiple_showSelectedValues: () => 'Vis kun valgte værdier.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' værdier valgt.',
  select_addToList: () => 'Føj til liste',
  select_addToListAvailable: () => 'Føj til liste tilgængelig',
  select_moreSearchOptions: () => 'Flere søgemuligheder',
  select_moreSearchOptionsAvailable: () => 'Flere søgemuligheder tilgængelige',
  select_noMatchesFound: () => 'Ingen matchninger blev fundet.',
  select_oneMatchFound: () => 'Én matchning blev fundet',
  select_requiredMessageDetail: () => 'Vælg en værdi.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => p['TOTAL_SIZE'] + ' matches fundet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' eller flere matches fundet',
  selectorAll_deselectAll: () => 'Fravælg alle',
  selectorAll_selectAll: () => 'Vælg alle',
  selector_selected: () => 'Afkrydsningsfelt markeret',
  selector_unselected: () => 'Afkrydsningsfelt ikke markeret',
  tabBarNavigationList_removeCueText: () => 'Kan fjernes',
  timeComponent_tooltipZoomIn: () => 'Zoom ind',
  timeComponent_tooltipZoomOut: () => 'Zoom ud',
  train_current: () => 'Aktuel',
  train_message_type: () => 'Meddelelsestype',
  train_not_visited: () => 'Ikke besøgt',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Trin ' + p['currentStep'] + ' af ' + p['numberOfSteps'],
  train_visited: () => 'Besøgt',
  userAssistance_learnMore: () => 'Lær mere',
  userAssistance_required: () => 'Påkrævet',
  vis_clearSelection: () => 'Ryd valg',
  vis_drillable: () => 'Kan bores',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' af ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Marquee-valg',
  vis_marqueeZoomTooltip: () => 'Marquee-zoom',
  vis_noData: () => 'Ingen data at vise',
  vis_panTooltip: () => 'Panorer',
  vis_stateLoaded: () => 'Indlæst',
  vis_stateLoading: () => 'Indlæser',
  vis_stateSelected: () => 'Valgt',
  vis_stateUnselected: () => 'Ikke valgt',
  warn: () => 'Advarsel'
};
export default bundle;
